import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter, Route} from 'react-router-dom';
import './i18n';
import App from './components/App';
import RootProvider from './context/root-context';
import {CookiesProvider} from 'react-cookie';

import { initializeGoogleAnalytics } from './helpers/gaHelper';

initializeGoogleAnalytics();

// entry point of the application
ReactDOM.render(
  <React.StrictMode>
    <CookiesProvider>
      <BrowserRouter>
        <Route path="/:language?">
          <RootProvider>
            <App/>
          </RootProvider>
        </Route>
      </BrowserRouter>
    </CookiesProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

